export default "__VITE_ASSET__pFpwO_zB__"